import ColorPaletteBase from './ColorPaletteBase.js';

export default class GradientPalette extends ColorPaletteBase {
  constructor(colorManager, onDblClickColor) {
    super(colorManager, '#gradientPalette');
    this._onDblClickColor = onDblClickColor;
    this._arrElColorSrc = this._elPalette.querySelectorAll('.color.src');
    
    this._arrElColorSrc.forEach((v, i) => {
      v.addEventListener('click', e => {
        this.setSrc(i, this._colorManager.get());
      });
      v.addEventListener('mouseup', e => {
        if(e.button !== 0) {
          this._colorMouseUpHandler(e)
        }
      });
    });
    this._elPalette.querySelector('.button.add').addEventListener('click', e => this.addColor());
    this._elPalette.querySelector('.button.remove').addEventListener('click', e => this.removeColor());
  }
  setSrc(idx, color) {
    const elColorSrc = this._arrElColorSrc[idx];
    this._setElColor(elColorSrc, color);
    this._makeGradient();
    this._selectColor(this._colorManager.get());
  }
  _setElColor(elColor, color) {
    const rgba = color.join(',');
    elColor.setAttribute('data-rgba', rgba);
    elColor.firstElementChild.style.backgroundColor = `rgba(${rgba})`;
  }
  _makeGradient() {
    const a = this._arrElColorSrc[0].getAttribute('data-rgba').split(',').map(v => Number(v));
    const b = this._arrElColorSrc[1].getAttribute('data-rgba').split(',').map(v => Number(v));
    const length = this._elColorList.children.length;
    for(let i = 0; i < length; ++i) {
      const elColor = this._elColorList.children[i];
      //const c = i / (length - 1);
      const c = (i + 1) / (length + 1);
      const color = [];
      let j;
      for(j = 0; j < 3; ++j) {
        color.push(Math.ceil(a[j] + (b[j] - a[j]) * c));
      }
      color.push(a[j] + (b[j] - a[j]) * c);
      this._setElColor(elColor, color);
    }
  }
  addColor() {
    const elColor = this._elTemplateColor.cloneNode(true);
    elColor.addEventListener('mouseup', e => this._colorMouseUpHandler(e));
    elColor.addEventListener('dblclick', this._onDblClickColor);
    this._elColorList.appendChild(elColor);
    this._makeGradient();
    this._selectColor(this._colorManager.get());
  }
  removeColor() {
    if(this._elColorList.children.length <= 1) return;
    this._elColorList.lastElementChild.remove();
    this._makeGradient();
    this._selectColor(this._colorManager.get());
  }
}
